// the code is adapter from Online extensionmessenger module
export function MessengerBuilder($q) {
    const markerElementSelector = "os33-extension-present";
    // IE doesn't support new CustomEvent() the only option is createEvent() approach
    // Chrome and FF support both ways; however they allow passing event arguments
    // only in former case (new CustomEvent()).
    // In order to have cross browser custom events with arguments we have to implement
    // both ways and pick one depending on the current browser.
    function buildCustomEventIe(eventName, details) {
        let customEvent = document.createEvent("CustomEvent");
        customEvent.initCustomEvent(eventName, true, true, details);
        return customEvent;
    }
    function buildCustomEventOthers(eventName, details) {
        return new CustomEvent(
            eventName,
            { detail: details });
    }
    function buildCustomEvent(eventName, details) {
        let customEvent;
        try {
            customEvent = buildCustomEventOthers(eventName, details);
        } catch(e) {
            customEvent = buildCustomEventIe(eventName, details);
        }
        return customEvent;
    }

    function randomString() {
        let text = "";
        const possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

        for (let i = 0; i < 5; i++)
            text += possible.charAt(Math.floor(Math.random() * possible.length));

        return text;
    }

    function dispatchCustomEventAsync(customEvent, callbackName) {
        // At this point we can pass a message from Portal page to Browser Extension
        // However we need a way of getting data back. To do this we need to pass a
        // callback function to Browser Extension; The obvious way is to pass it as an
        // event argument however browsers do not allow this.
        // We register single callback here then fire the corresponding CustomEvent;
        // the extension handles it and fires another CustomEvent back
        // this way our page has a chance to get data from extension asynchronously
        const self = this,
            deferred = $q.defer(),
            callback = function (e) {
                // The callback must be executed only once, removing the handler
                self.marker.removeEventListener(callbackName, callback, false);
                const result = (typeof e.detail === "string")
                    ? JSON.parse(e.detail)
                    : e.detail;
                if (result && result.exception) {
                    deferred.reject(result);
                } else {
                    deferred.resolve(result);
                }
            };
        if (this.extensionReady) {
            this.marker.addEventListener(callbackName, callback, false);
            this.marker.dispatchEvent(customEvent);
        } else {
            this.eventsQueue.push({
                event: customEvent,
                callback: callback,
                callbackName: callbackName
            });
        }
        return deferred.promise;
    }
    function checkExtensionReady() {
        const deferred = $q.defer();
        setTimeout(tryMarker, 100);
        function tryMarker() {
            const marker = document.getElementById(markerElementSelector);
            if (marker && marker.getAttribute("data-events") === "ready") {
                deferred.resolve(marker);
            } else {
                setTimeout(tryMarker, 1000);
            }
        }
        return deferred.promise;
    }
    const Constructor = function() {
        const self = this;
        this.eventsQueue = [];
        this.extensionReady = false;
        // The messaging relies on DOM CustomEvents. Therefore we need a DOM element on the page
        // Both the page and the extension should be able to locate it, which might not be the case
        // at the very beginning. Polling for the element is needed here.
        checkExtensionReady()
            .then(function(marker) {
                self.extensionReady = true;
                self.marker = marker;
                while(self.eventsQueue.length) {
                    const e = self.eventsQueue.splice(0, 1)[0];
                    marker.addEventListener(e.callbackName, e.callback, false);
                    marker.dispatchEvent(e.event);
                }
            })
            .catch(function() {
                console.log("Error checking if browser extension is ready");
            });
    };
    // Notifies extension about successful login
    Constructor.prototype.portalLogin = function() {
        return dispatchCustomEventAsync.call(
            this,
            buildCustomEvent("PortalLogin"),
            "PortalLoginCallback");
    };
    // Sends custom message to extension
    Constructor.prototype.portalMessage = function (type, action, parameters, callbackName) {
        const cbName = callbackName ? callbackName + randomString() : "PortalMessageCallback";
        return dispatchCustomEventAsync.call(
            this,
            buildCustomEvent(
                "PortalMessage",
                {
                    type: type,
                    action: action,
                    parameters: parameters,
                    callbackName: cbName
                }),
            cbName);
    };
    return Constructor;
}



// WEBPACK FOOTER //
// ./src/scripts/services/messenger.js